export class CallPermission {
    public static readonly read: string = 'call:read:call';
}
